<script lang="ts">
	import type { MarkComponentProps } from "@portabletext/svelte";
	import Button from "../Button.svelte";

	interface Props {
		portableText: MarkComponentProps<{
			href?: string;
			blank?: boolean;
			style?: string;
			arrow?: boolean;
		}>;
		children?: import("svelte").Snippet;
	}

	let { portableText, children }: Props = $props();

	const isValidUrl = (url: string | undefined): boolean => {
		if (!url) return false;
		try {
			new URL(url, "https://www.ishavskraft.no");
			return true;
		} catch {
			console.warn(`Invalid URL in content: ${url}`);
			return false;
		}
	};

	let { value } = $derived(portableText);
	let validHref = $derived(isValidUrl(value.href) ? value.href : undefined);
	let blank = $derived(value.blank || false);
	let defaultStyle = $derived(!value.style || !!value.style?.match(/link/));
	let arrow = $derived(value.arrow || false);
</script>

{#if validHref}
	<Button
		{arrow}
		{defaultStyle}
		class={value.style}
		href={validHref}
		target={blank ? "_blank" : undefined}
		rel={blank ? "noopener noreferrer" : undefined}
	>
		{@render children?.()}
	</Button>
{:else}
	{@render children?.()}
{/if}
